import { connect } from 'react-redux';
import {
  completeCaptcha,
  expireCaptcha,
  setEmail,
  setEmail2,
  setFirstName,
  setLastName,
  setPhone,

  toggleGTIReceipt,
  setCusNumber,
  setProvinciaId,
  setCantonId,
  setDistritoId,
  setBarrioId,
  setDireccion,
  setTipoIdent,
  setTipoDoc,
  setAreaTelefono,
  setNumTelefono,
  setCorreo,
  setFullName,
  resetGTI,
  getProvincias,
  getCantons,
  getDistritos,
  getBarrios,

  setPromo,
  setHasAcceptedTerms,
  setHasYoungChildren,
  trySelectPromo,
  resetDiscount,
  setCustomerCardNumber,
  setUsedLocalStorage
} from '../../actions/checkout';
import { tryResetApp } from '../../actions/index';
import { tryNavigateSequence } from '../../actions/navigation';
import { getLocationName } from '../../selectors/bookingLocation';
import { getPrice } from '../../selectors/index';
import { getDiscount } from '../../selectors/discount';
import { roundThis } from '../../utilities/utils';
import Checkout from './Checkout';

const mapStateToProps = (state) => {
  const priceInfo = getPrice(state, getDiscount(state));

  return {
    locationName: state.bookingLocation.selectedLocation ? getLocationName(state.bookingLocation.selectedLocation) : '',
    selectedDate: state.date.selectedDate || new Date(),
    firstName: state.checkout.firstName,
    lastName: state.checkout.lastName,
    email: state.checkout.email,
    email2: state.checkout.email2,
    phone: state.checkout.phone,

    GTIReceipt: state.checkout.GTIReceipt,
    cusNumber: state.checkout.cusNumber,
    provincia: state.checkout.provincia,
    provinciaId: state.checkout.provinciaId,
    cantons: state.checkout.cantons,
    cantonId: state.checkout.cantonId,
    distritos: state.checkout.distritos,
    distritoId: state.checkout.distritoId,
    barrios: state.checkout.barrios,
    barrioId: state.checkout.barrioId,
    direccion: state.checkout.direccion,
    tipoIdent: state.checkout.tipoIdent,
    tipoDoc: state.checkout.tipoDoc,
    areaTelefono: state.checkout.areaTelefono,
    numTelefono: state.checkout.numTelefono,
    correo: state.checkout.correo,
    fullName: state.checkout.fullName,

    promo: state.checkout.promo,
    captchaCompleted: (state.checkout.captchaResponse && state.checkout.captchaResponse !== '') ? true : false,
    enableGiftCard: state.checkout.giftCardEnabled,
    isExtraLife: state.date.isExtraLife,
    totalBool: roundThis(Math.max(priceInfo.basePrice - priceInfo.discount, 0) + priceInfo.tax - state.giftCard.total_amount) >= 0,
    isCostaRica: state.bookingLocation.selectedLocationId === 28, // Change this to be less sketch
    languageObj: state.language.check_out_js,
    hasAcceptedTerms: state.checkout.hasAcceptedTerms,
    hasYoungChildren: state.checkout.hasYoungChildren,
    discountExists: (priceInfo.discount !== 0) ? true : false,
    customerCardNumber: state.checkout.customerCardNumber,
    usedLocalStorage: state.checkout.usedLocalStorage,
    fullStationStateObj: state.station,
  }
};

const mapDispatchToProps = (dispatch) => ({
  completeCaptcha: (response) => dispatch(completeCaptcha(response)),
  expireCaptcha: () => dispatch(expireCaptcha()),
  resetApp: () => dispatch(tryResetApp()),
  setEmail: (email) => dispatch(setEmail(email)),
  setEmail2: (email2) => dispatch(setEmail2(email2)),
  setFirstName: (firstName) => dispatch(setFirstName(firstName)),
  setLastName: (lastName) => dispatch(setLastName(lastName)),
  setPhone: (phone) => dispatch(setPhone(phone)),

  toggleGTIReceipt: (GTIReceipt) => dispatch(toggleGTIReceipt(GTIReceipt)),
  setCusNumber: (cusNumber) => dispatch(setCusNumber(cusNumber)),
  setProvinciaId: (provinciaId) => dispatch(setProvinciaId(provinciaId)),
  setCantonId: (cantonId) => dispatch(setCantonId(cantonId)),
  setDistritoId: (distritoId) => dispatch(setDistritoId(distritoId)),
  setBarrioId: (barrioId) => dispatch(setBarrioId(barrioId)),
  setDireccion: (direccion) => dispatch(setDireccion(direccion)),
  setTipoIdent: (tipoIdent) => dispatch(setTipoIdent(tipoIdent)),
  setTipoDoc: (tipoDoc) => dispatch(setTipoDoc(tipoDoc)),
  setAreaTelefono: (areaTelefono) => dispatch(setAreaTelefono(areaTelefono)),
  setNumTelefono: (numTelefono) => dispatch(setNumTelefono(numTelefono)),
  setCorreo: (correo) => dispatch(setCorreo(correo)),
  setFullName: (fullName) => dispatch(setFullName(fullName)),
  resetGTI: () => dispatch(resetGTI()),
  getProvincias: () => dispatch(getProvincias()),
  getCantons: (provinciaId) => dispatch(getCantons(provinciaId)),
  getDistritos: (cantonId) => dispatch(getDistritos(cantonId)),
  getBarrios: (barriosId) => dispatch(getBarrios(barriosId)),

  resetDiscount: () => dispatch(resetDiscount()),
  trySelectPromo: (promo, override) => dispatch(trySelectPromo(promo, override)),
  setPromo: (promo) => dispatch(setPromo(promo)),
  transitionBack: () => dispatch(tryNavigateSequence(false)),
  transitionForward: () => dispatch(tryNavigateSequence(true)),
  setHasAcceptedTerms: (hasAcceptedTerms) => dispatch(setHasAcceptedTerms(hasAcceptedTerms)),
  setHasYoungChildren: (hasYoungChildren) => dispatch(setHasYoungChildren(hasYoungChildren)),
  setCustomerCardNumber: (cardNumber) => dispatch(setCustomerCardNumber(cardNumber)),
  setUsedLocalStorage: () => dispatch(setUsedLocalStorage())
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
